import { render, staticRenderFns } from "./WindingSection.vue?vue&type=template&id=545adc2a&scoped=true&"
import script from "./WindingSection.vue?vue&type=script&lang=js&"
export * from "./WindingSection.vue?vue&type=script&lang=js&"
import style0 from "./WindingSection.vue?vue&type=style&index=0&id=545adc2a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545adc2a",
  null
  
)

export default component.exports